export const SAVE_PHYSIOTHERAPY_ASSESSMENT_CONSULTATION_CLINICAL_NOTES = "SAVE_PHYSIOTHERAPY_ASSESSMENT_CONSULTATION_CLINICAL_NOTES";
export const LOAD_UNMATCHED_PHYSIOTHERAPY_MGR_REFERRAL = "LOAD_UNMATCHED_PHYSIOTHERAPY_MGR_REFERRAL";
